<div class="col-md-12" *ngIf="isLoading" style="position: fixed; top: 0; left: 0; width: 100%;height: 100%;    z-index:99;">
  <app-busy [message]="message"></app-busy>
</div>
<div class="row">
  <div style="margin-top:10px; margin-bottom:-10px;">
    <h5><span style="padding-right:15px"></span> <i class="fa fa-cogs"></i><b> Manage Permit Application Approvals</b></h5>
  </div>
</div>
<hr>
<fieldset class="scheduler-border" style="align-content: float-right;" >
  <legend class="scheduler-border tsk-display">Filters</legend>
  <!-- <legend class="scheduler-border tsk-display blackcontrol">Filters</legend> -->
  <div class="row" style="margin:15px auto!important;padding-left:0;">
    <div class="col-3 table-responsive-sm" style="width:100%!important;margin:0px;padding:0px;">
      <table class="" style="width:80%%!important;margin:0px;padding:0px;" border="0">
        <tr class="rmp-all">
          <td class="col-md-2">
         <input type="text" style="width:200px!important;height:35px" class="form-control form-control-lg" [(ngModel)]="carrierName" placeholder="Filter by Carrier Name..." title="Enter the Carrier Name to filter by..." (keypress)="checkKey($event)">
          </td>
    <td class="col-md-2">
     <input type="text" style="width:200px!important;height:35px" class="form-control form-control-lg" [(ngModel)]="carrierNumber" placeholder="Filter by Account Number..." title="Enter the Account Number to filter by..." (keypress)="checkKey($event)">
    </td>
    <td class="col-md-2">
     <input type="text" style="width:200px!important;height:35px" class="form-control form-control-lg" [(ngModel)]="permitNumber" placeholder="Filter by Permit Number..." title="Enter the Permit Number to filter by..." (keypress)="checkKey($event)">
    </td>
    <!-- <div class="col-4 resizer" style="width:350px; padding:0px" title="Select one or more statuses to filer by..."> -->
      <td class="col-3 resizer">
      <div class="col-9 resizer" style="width:350px; padding:0px;" title="Select one or more statuses to filer by...">  
      <ng-multiselect-dropdown [placeholder]="'Filter by one or more statuses...'"
                               [data]="statuses"
                               [(ngModel)]="selectedItems"
                               [settings]="dropdownSettings"
                               (onSelect)="onItemSelect($event)"
                               (onDeSelect)="onDeSelect($event)"
                               (onSelectAll)="onSelectAll($event)">
      </ng-multiselect-dropdown>
    </div>
    </td>  
    <td>      
        <span title="Apply filters..." (click)="onSearch()" class="btn btn-primary btn-sm " style="margin-right: 6px !important;"><i class="fa fa-filter" aria-hidden="true"></i></span>
      </td>
      <td> 
            <span (click)="onReset()" title="Reset filters..." class="btn btn-success btn-sm "><i class="fa fa-undo" aria-hidden="true"></i></span>        
      </td>   
    </tr>
  </table>
  </div>    
  </div>
</fieldset>
<br>
<button title="Refresh Permit Applications" style="margin-top:-5px; color:black; background:white" class="btn btn-secondary btn-sm pull-left" (click)="loadAccounts(utility.page, pageSize, isDef)"><i class="fa fa-refresh" aria-hidden="true"></i></button>
<fieldset style="margin:0px;padding:0px;">
  <legend class="scheduler-border tsk-display blackcontrol">Permit Applications</legend>
  <div class="row" style="margin:0px auto!important;padding:0px">
    <div class="col-12" style="margin:0px!important;padding:0px!important;">
      <table class="table table-sm table-striped" style="width:100%;">
        <thead class="thead-inverse">
          <tr class="hd-clpse">
            <th class="bfr-end-col">
              Lock
            </th>
            <th class="bfr-end-col">
              Acc No
              <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagAN == 2),'fa-sort-desc sort-d': (flags.flagAN == 3), 'fa-sort':(flags.flagAN == 1) }" (click)="onSort(1)"></i>
            </th>
            
            <th class="bfr-end-col">
              Name
              <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagNM == 2),'fa-sort-desc sort-d': (flags.flagNM == 3), 'fa-sort':(flags.flagNM == 1) }" (click)="onSort(2)"></i>
            </th>
            <th class="bfr-end-col">
              Balance
              <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagNM == 2),'fa-sort-desc sort-d': (flags.flagNM == 3), 'fa-sort':(flags.flagNM == 1) }" ></i>
            </th>
            <!-- <th class="bfr-end-col">
              Lead User
              <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagLU == 2),'fa-sort-desc sort-d': (flags.flagLU == 3), 'fa-sort':(flags.flagLU == 1) }" (click)="onSort(3)"></i>
            </th>
            <th class="bfr-end-col">
              Carrier Type
              <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagCT == 2),'fa-sort-desc sort-d': (flags.flagCT == 3), 'fa-sort':(flags.flagCT == 1) }" (click)="onSort(4)"></i>
            </th> -->
            <th class="bfr-end-col">
              App
              <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagAP == 2),'fa-sort-desc sort-d': (flags.flagAP == 3), 'fa-sort':(flags.flagAP == 1) }" (click)="onSort(5)"></i>
            </th>
            <!-- <th class="bfr-end-col">
              Permit Num
              <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagPN == 2),'fa-sort-desc sort-d': (flags.flagPN == 3), 'fa-sort':(flags.flagPN == 1) }" (click)="onSort(6)"></i>
            </th> -->
            <th class="bfr-end-col">
              Type
              <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagPT == 2),'fa-sort-desc sort-d': (flags.flagPT == 3), 'fa-sort':(flags.flagPT == 1) }" (click)="onSort(7)"></i>
            </th>
            <th class="bfr-end-col">
              Num Permits
            </th>
            <th class="bfr-end-col end-col">
              Submitted On
              <i style="vertical-align:middle; float:right;" class="fa " [ngClass]="{'fa-sort-asc sort-a': (flags.flagDS == 2),'fa-sort-desc sort-d': (flags.flagDS == 3), 'fa-sort':(flags.flagDS == 1) }" (click)="onSort(8)"></i>
            </th>
            <th class="bfr-end-col">
              Status
              <i style="vertical-align:middle; float:right;" class="fa " [ngClass]="{'fa-sort-asc sort-a': (flags.flagST == 2),'fa-sort-desc sort-d': (flags.flagST == 3), 'fa-sort':(flags.flagST == 1) }" (click)="onSort(9)"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="tbl-row" *ngFor="let item of permits | orderBy: criteria : direction | paginate: {itemsPerPage:pageSize, currentPage: utility.page ,totalItems: count}">
            <td class="bfr-end-col">
              <span *ngIf="item.isLocked==true" title="Locked by '{{item.isLockedBy}}', Click to unlock" style="margin: 0%" class="btn btn-md pull-center" (click)="unLockApplication(item)" >
                <i class="fa fa-lock" aria-hidden="true" style="color: red;"></i>                
              </span>
              <span *ngIf="item.isLocked==false || item.isLocked==undefined " title="Unlocked" style="margin: 0%" class="btn btn-md pull-center" >
                <i class="fa fa-unlock" aria-hidden="true" style="color: green;"></i>                
              </span>
            </td>
            <td class="bfr-end-col">{{item.AccountNumber}}</td>
            <td class="bfr-end-col" style="width: 150px;" title="{{item.Name}}">{{item.Name}}</td>
            <td class="bfr-end-col" style="width: 150px;" title="{{formatCurrency(item.AccountBalance)}}">{{formatCurrency(item.AccountBalance)}}</td>
            <!-- <td class="bfr-end-col">{{item.LeadUser}}</td>
            <td class="bfr-end-col">{{item.CarrierType}}</td> -->
            <td class="bfr-end-col text-center">{{item.ApplicationNumber}}</td>
            <!-- <td class="bfr-end-col text-center">{{item.permit_num}}</td> -->
            <td class="bfr-end-col">{{item.PermitType}}</td>
            <td class="bfr-end-col text-center">{{item.number_of_permits}}</td>
            <td class="bfr-end-col">{{item.DateSubmitted?.toLocaleString() | date:'yyyy/MM/dd HH:mm'}}</td>
            <td class="bfr-end-col">{{item.status_desc}}</td>
            <td class="btn-show end-col" style="width:130px!important;">
              <span title="View Permit Application" class="btn btn-primary btn-sm pull-left" [routerLink]="['/carrier/permit/application/view',item.id]"><i class="fa fa-list" aria-hidden="true"></i></span>
              <span  *ngIf="item.isLocked != true" title="Process Permit Application" style="margin: 0%" class="btn btn-success btn-sm pull-center" (click)="onProcessClick(2,item)">
                <img  src="/assets/permit-viewer2.png" class="permit-view" />                               
              </span> 
              
              <span  *ngIf="item.isLocked == true && item.isLockedBy == currentUserName" title="Process Permit Application" style="margin: 0%" class="btn btn-success btn-sm pull-center" (click)="onProcessClick(2,item)" >
                <img  src="/assets/permit-viewer2.png" class="permit-view" />  
              </span> 

              <span style="background-color: grey;"  *ngIf="item.isLocked == true && item.isLockedBy != currentUserName" title="application locked" style="margin: 0%" class="btn btn-secondary btn-sm pull-center" >
                <img style="background-color: grey;" src="/assets/permit-viewer2.png" class="permit-view" />  
              </span> 
              <button [disabled]="!((isPrintable(item.status_id) && !(item.isLocked)) || (isPrintable(item.status_id) && (item.isLocked && item.isLockedBy != '' && item.isLockedBy != null && item.isLockedBy!= undefined && item.isLockedBy == currentUserName)))" title="Print permits" style="margin: 0%" class="btn btn-secondary btn-sm pull-right" (click)="onProcessPrint(item)"><i class="fa fa-print" aria-hidden="true"></i></button>
              
            </td>
          </tr>
        </tbody>
        <tfoot style="padding:0px;margin:0px;">
          <tr *ngIf="count > 10" style="padding-left:0px;margin-left:0px;">
            <td colspan="8" class="rm-brd" style="padding-left:0px;margin-left:0px;">
              <div class="row">
                <div class="col-2">
                  <div class="input-group mb-3 rm-brd" style="width:125px!important;height:30px!important;">
                    <div class="input-group-prepend">
                      <label class="input-group-text form-control-sm show-h" for="show-id">Show:</label>
                    </div>
                    <select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="pageSize" (change)="onChange()">
                      <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-8 text-center">
                  <pagination-controls (pageChange)="utility.page = onNextOrPrevious($event)" style="margin-left:0px!important;padding-left:0px!important;"></pagination-controls>
                </div>
              </div>
            </td>
          </tr>
          <tr *ngIf="isEmpty">
            <td colspan="4" class="rm-brd">
              <span class="text-info text-small">No permit applications found.</span>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</fieldset>


